<template>
  <div style="padding:50px; background-color:#eee;">
    <h1 style="width:100%;">Förderer</h1>
    <div>
      <img style="height:200px" :src="$_getIcon('dfg_logo_schriftzug_blau_foerderung_4c.jpg')" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss"
 scoped>
</style>


// WEBPACK FOOTER //
// Foerderer.vue?79921996